/**
 * Normalizes input values by removing whitespace and lowercasing
 * Returns a boolean indicating whether or not the normalized values match
 * 
 * @param {Date} a First value
 * 
 * @returns {string} Boolean indicating with the inputs match
 */
function formattedDate(a) {
   
    var month = (a.getMonth() + 1);
    var day = (a.getDate());
    var year = (a.getFullYear());
    return month + "/" + day + "/" + year;
}

module.exports = {
    formattedDate
};